import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/QuestionBlock.jsx';
import accordion_arrow from '../img/accordion_arrow.svg';
import {ReactSVG} from 'react-svg';
import ReactDOM from 'react-dom';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            ui: this.uiStates.INITIAL
        };

        this.faqRef = React.createRef();
        return this;
    }

    componentDidMount() {
        this.initAccordion();
    }

    initAccordion() {
        const root = this.faqRef.current;

        if (!root) return;

        const accordions = root.querySelectorAll('.accordion-faq-new');

        accordions.forEach(acc => {
            const title = acc.querySelector('.accordion-faq-new__title');
            const text = acc.querySelector('.accordion-faq-new__text');

            if (!title || !text) return;

            text.style.display = 'none';

            const iconContainer = document.createElement('div');
            iconContainer.classList.add('accordion-faq-new__arrow');
            title.appendChild(iconContainer);
            ReactDOM.render(<ReactSVG src={accordion_arrow} />, iconContainer);

            title.addEventListener('click', () => {
                const isVisible = text.style.display === 'block';
                text.style.display = isVisible ? 'none' : 'block';
                acc.classList.toggle('accordion-faq-new_open', !isVisible);
            });
        });
    }
}
